import { useOnlyFansCreators } from "@/common/hooks/useOnlyFansCreators";
import { OnlyFansCreator } from "../OnlyFansCreator";
import "./OnlyFansCreatorsModule.scss";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { FeedModuleContainer } from "@/components/player-feed/FeedModules/FeedModuleContainer";
import { FeedModuleTypeEnum } from "@/common/services/types";

interface IOnlyFansCreatorsModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const OnlyFansCreatorsModule = ({ moduleId, moduleType }: IOnlyFansCreatorsModule) => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const { adCreators } = useOnlyFansCreators("module", 4, !isDesktop);

  if (isDesktop) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <div className="OnlyFansCreatorsModule">
        <h3 className="title">Onlyfans creators you might enjoy:</h3>
        <div className="grid">
          {adCreators.map((adCreator) =>
            <OnlyFansCreator
              key={adCreator.extra.id}
              name={adCreator.extra.name}
              link={adCreator.link}
              image={adCreator.extra.imgUrl}
            />
          )}
        </div>
      </div>
    </FeedModuleContainer>
  );
};
